export const FETCH_PRINT_PACKAGE = {
    REQUEST: 'PACKAGE.FETCH_PRINT_PACKAGE.REQUEST',
    SUCCESS: 'PACKAGE.FETCH_PRINT_PACKAGE.SUCCESS',
    FAILED: 'PACKAGE.FETCH_PRINT_PACKAGE.FAILED',
};